import dingTalk from "dingtalk-jsapi";

const NOT_IN_DINGTALK = "notInDingTalk";
const WORKBENCH_PLATFORMS = [
	"pc",
	"android",
	"ios",
	"gdtPc",
	"gdtAndroid",
	"gdtIos",
	"gdtStandardAndroid",
	"gdtStandardIos",
	"harmony",
	"windows",
	"mac",
];

function isWorkbenchRuntime(client) {
	const environment = client && client.env;
	const platform = environment && environment.platform;
	return Boolean(
		typeof platform === "string" &&
		platform !== NOT_IN_DINGTALK &&
		WORKBENCH_PLATFORMS.indexOf(platform) !== -1,
	);
}

window.mwDingTalk = dingTalk;
window.mwDingTalkRuntime = {
	isWorkbench: () => isWorkbenchRuntime(window.mwDingTalk),
};
